export const messagesAdmEstablishments = {
    pt: {
        message:{
            activated: "Ativado",
            confirmEstabDeactivation: "Confirma desativação do estabelecimento?",
            credentials: "Credenciais",
            credentialsIdTooltip: "ID da conta da Twilio do estabelecimento",
            credentialsServiceIdTooltip: "Número utilizado para o envio de mensagens",
            credentialsTokenTooltip: "Token de acesso à API da conta do Twillio do estabelecimento",
            creditManagement: "Gerenciamento de Créditos",
            deactivateEstablishment: "Desativar estabelecimento",
            establishmentCountry: "País do Estabelecimento",
            establishmentEmail: "E-mail do Estabelecimento",
            establishmentName: "Nome do Estabelecimento",
            establishmentWebsite: "Website do Estabelecimento",
            form: "Formulário",
            formSubmitted: "Formulário Enviado",
            generateNewNumber: "Gerar novo número",
            partnerManagement: "Gerenciamento de Parceiro",
            registerEstablishment: "Cadastrar estabelecimento",
            noPartner: "Sem Parceiro",
            numberMigration: "Migração de Número",
            selectProcessStatus: "Selecione o status do processo",
            tooltipDisabledWhatsApp: "O processo para integração do WhatsApp ainda não foi iniciado. Para fazê-lo, submeta o formulário tanto no site do Twillio como aqui.",
            waitingMetaApproval: "Esperando Aprovação do Meta",
            whatsAppConfig: "Configuração WhatsApp"
        }
    },
    es: {
        message:{
            activated: "Activado",
            confirmEstabDeactivation:"¿Confirma la desactivación del establecimiento?",
            credentials: "Cartas credenciales",
            credentialsIdTooltip: "ID de cuenta Twilio del establecimiento",
            credentialsServiceIdTooltip: "Número utilizado para enviar mensajes",
            credentialsTokenTooltip: "Token de acceso API para la cuenta Twillio del establecimiento",
            creditManagement:"Gestión de crédito",
            deactivateEstablishment:"Desactivar el establecimiento",
            establishmentCountry: "País de establecimiento",
            establishmentEmail: "Correo electrónico del establecimiento",
            establishmentName: "Nombre del establecimiento",
            establishmentWebsite: "Sitio web del establecimiento",
            form: "Formulario",
            formSubmitted: "Formulario Enviado",
            generateNewNumber: "Generar nuevo número",
            partnerManagement:"Gestión de socios",
            registerEstablishment:"Registro del establecimiento",
            noPartner:"Sin un socio",
            numberMigration: "Migración de número",
            selectProcessStatus: "Seleccionar estado del proceso",
            tooltipDisabledWhatsApp: "El proceso de integración de WhatsApp aún no ha comenzado. Para hacerlo, envíe el formulario tanto en el sitio web de Twillio como aquí.",
            waitingMetaApproval: "Esperando la aprobación de Meta",
            whatsAppConfig: "Configuración WhatsApp"
        }
    },
    en: {
        message:{
            activated: "Activated",
            confirmEstabDeactivation: "Confirm establishment deactivation?",
            credentials: "Credentials",
            credentialsIdTooltip: "Establishment's Twilio account ID",
            credentialsServiceIdTooltip: "Number used to send messages",
            credentialsTokenTooltip: "API access token for the establishment's Twillio account",
            creditManagement: "Credit Management",
            deactivateEstablishment: "Deactivate establishment",
            establishmentCountry: "Establishment Country",
            establishmentEmail: "Establishment Email",
            establishmentName: "Establishment Name",
            establishmentWebsite: "Establishment Website",
            form: "Form",
            formSubmitted: "Form Submitted",
            generateNewNumber: "Generate new number",
            partnerManagement: "Partner Management",
            registerEstablishment: "Register establishment",
            noPartner: "No Partner",
            numberMigration: "Number Migration",
            selectProcessStatus: "Select process status",
            tooltipDisabledWhatsApp: "he WhatsApp integration process has not yet started. To do so, submit the form both on the Twillio website and here.",
            waitingMetaApproval: "Waiting for Meta Approval",
            whatsAppConfig: "WhatsApp Configuration"

        }
    }
}
